import { render, staticRenderFns } from "./salesInstallments.vue?vue&type=template&id=26b60816&"
import script from "./salesInstallments.vue?vue&type=script&lang=js&"
export * from "./salesInstallments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports